import TermsOfUse from "../en/terms-of-use";
export default TermsOfUse;
